import { leaseAreaPresentation } from "./leaseAreaPresentation.js";

export function leaseAreaSummary(lease, suiteDescriptor, asOf = new Date()) {
  const areas = Array.isArray(lease?.areas) ? lease.areas : [];
  if (areas.length > 0) {
    const { active, expiredCount } = leaseAreaPresentation(lease, asOf);
    const names = active.map((area) => area?.name?.trim()).filter(Boolean);
    const name = names.length === 1 ? names[0]
      : names.length > 1 ? `${names.slice(0, -1).join(", ")} & ${names[names.length - 1]}`
        : active.length ? "Active area details unavailable" : "No active areas";
    return `${name}${expiredCount ? ` (+${expiredCount} expired)` : ""}`;
  }
  if (typeof suiteDescriptor !== "string" || !suiteDescriptor.trim()) return null;
  const descriptor = suiteDescriptor.trim();
  return /^(?:entire|whole)\s+(?:the\s+)?building\b/i.test(descriptor)
    ? "Entire Building"
    : descriptor;
}